export const b2bRecurringInvestmentsTranslations = {
  title: 'Recurring voluntary deposits',
  name: 'Recurring voluntary deposit',
  empty: 'No recurring voluntary deposits to show',
  list: {
    title: 'Planned operations',
  },
  show: {
    title: 'Details',
    linked_operations_title: 'Linked operations',
    linked_operations_empty: 'No operation has been generated yet',
  },
  create: {
    type: 'Recurring voluntary payment',
    title: 'Create recurring voluntary deposit',
    button: 'Create',
    type_subtitle: 'Create a recurring payment',
    summary: {
      type: 'Operation type',
      total_per_occurrence: 'Total amount to be paid by occurrence',
      total_mc_per_occurrence: 'Total MC amount to be paid by occurrence*',
      mc_ceiling: '*Only up until the employee MC ceiling is consumed',
    },
    messages: {
      start_date_in_past: 'The start date cannot be in the past',
      no_valid_mandate:
        'The user has no valid mandate. Please make sure you add a valid mandate before setting a recurring voluntary payment for this user.',
    },
    actions: {
      success: 'Recurring voluntary deposit created',
      failure: 'Failed to create recurring voluntary deposit: %{error}',
    },
  },
  fields: {
    id: 'ID',
    b2b_employee_id: 'Employee ID',
    b2b_contract_id: 'Contract ID',
    b2b_company_plan_id: 'Company Plan ID',
    b2b_company_plan_type: 'Equipment',
    status: 'Status',
    execution_frequency: 'Frequency',
    user_input_amount: 'Amount',
    user_currency: 'Currency',
    payer: 'Payer',
    initiator: 'Initiator',
    deductibility: 'Deductibility',
    execution_starting_date: 'Start date',
    next_execution_at: 'Next execution',
    last_executed_at: 'Last executed',
    created_at: 'Created',
    updated_at: 'Updated',
  },
  status: {
    active: 'Active',
    deleted: 'Cancelled',
  },
  frequency: {
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    semi_annually: 'Semi-annually',
    yearly: 'Yearly',
  },
  payer: {
    employee: 'Employee',
    company: 'Company',
  },
  initiator: {
    user: 'Employee',
    shares: 'Shares',
    broker: 'Broker',
    bo: 'Backoffice',
  },
  allocations: {
    title: 'Allocation',
    fields: {
      id: 'Instrument ID',
      b2b_recurring_investment_id: 'Recurring Investment ID',
      source: 'Source',
      instrument_symbol: 'Symbol',
      instrument_name: 'Name',
      allocation_percentage: 'Allocation (%)',
      allocation_amount: 'Amount',
      user_currency: 'Currency',
      b2b_fully_managed_allocation_id: 'Grid ID',
      b2b_fully_managed_allocation_template_id: 'Investor profile ID',
      created_at: 'Created at',
      updated_at: 'Updated at',
    },
    source: {
      allocation: 'Chosen by employee',
      managed_grid: 'Managed grid',
    },
  },
};
